import {Grid, Stack} from "@mui/material";
import React from "react";
import FooterMenu from "./FooterMenu";

import C076Newsletterlinks from "../../content/C076Newsletterlinks/C076Newsletterlinks";
import C050BankContactData from "../../content/C050BankContactData/C050BankContactData";
import C074CopyrightNavi from "../../content/C074CopyrightNavi/C074CopyrightNavi";
import C073TrustBar from "../../content/C073TrustBar/C073TrustBar";
import C071SocialRow from "../../content/C071SocialRow/C071SocialRow";
import useWindowSize from "../../../utility/useWindowSize";


interface Props {
    items: Array<any>,
    CAEGlobalSettings?: any,
    columns: number,
    pageProps?: any
}

function C072FooterColumnLayout(props: Props) {
    const {lowerThanWindowLarge} = useWindowSize()

    const columnCount = (index: number) => {
        if (props.columns == 4) {
            return 3
        } else {
            if (index == 0) {
                return 5
            } else if (index == 1) {
                return 4
            } else {
                return 3
            }
        }
    }

    const layoutElements = (i: any, index: number, padding: number | string) => {
        return <React.Fragment key={index}>
            {i.viewtype == "asSocialRow" ?
                <C071SocialRow key={index} cmCollection={i} CAEGlobalSettings={props.CAEGlobalSettings}/> : null}
            {i.viewtype == "asFooterCopyright" ?
                <C074CopyrightNavi key={index} cmCollection={i} CAEGlobalSettings={props.CAEGlobalSettings} pageProps={props.pageProps}/> : null}
            {i.viewtype == "asFooterTrust" ?
                <C073TrustBar key={index} cmCollection={i}/> : null}
            {i.viewtype == "c050_bankcontactdata" ?
                <C050BankContactData key={index} CAEGlobalSettings={props.CAEGlobalSettings} padding={padding}/> : null}
            {i.viewtype == "c076_newsletterlinks" ?
                <C076Newsletterlinks key={index} cmCollection={i}/> : null}
            {i.viewtype == null ?
                <FooterMenu indexKey={index} items={i.items} teaserTitle={i.teaserTitle} padding={padding}/> : null}
        </React.Fragment>
    };

    const desktopGrid = <Grid container justifyContent={"center"}>
        {props.items.map((i, index) => {
                return <Grid item key={index} sx={{
                    borderBottom: props.columns == 4 || lowerThanWindowLarge ? '1px solid #e0e0e0' : '',
                    pb: 4,
                }} md={columnCount(index)} sm={12} display={'flex'} alignItems={'stretch'}>
                    {layoutElements(i, index, lowerThanWindowLarge ? 0 : '48px 16px 16px 16px')}
                </Grid>

            }
        )}
    </Grid>;
    const mobileGrid = <Stack spacing={2}>
        {
            props.items.map((i, index) => {
                    return layoutElements(i, index, 0)
                }
            )
        }
    </Stack>
    return lowerThanWindowLarge ? mobileGrid : desktopGrid;
}

export default C072FooterColumnLayout